const Items = [
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-1',
        theme: 'Todos Han Pecado',
        ref: 'Romanos 3:23',
        text: {
            lbla: 'por cuanto todos pecaron y no alcanzan la gloria de Dios,'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-2',
        theme: 'Todos Han Pecado',
        ref: 'Isaias 53:6',
        text: {
            lbla: 'Todos nosotros nos descarriamos como ovejas, nos apartamos cada cual por su camino; pero el Señor hizo que cayera sobre Él la iniquidad de todos nosotros.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-3',
        theme: 'La Pena del Pecado',
        ref: 'Romanos 6:23',
        text: {
            lbla: 'Porque la paga del pecado es muerte, pero la dádiva de Dios es vida eterna en Cristo Jesús Señor nuestro.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-4',
        theme: 'La Pena del Pecado',
        ref: 'Hebreos 9:27',
        text: {
            lbla: 'Y así como está decretado que los hombres mueran una sola vez, y después de esto, el juicio,'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-5',
        theme: 'Cristo Pago la Pena',
        ref: 'Romanos 5:8',
        text: {
            lbla: 'Pero Dios demuestra su amor para con nosotros, en que siendo aún pecadores, Cristo murió por nosotros.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-6',
        theme: 'Cristo Pago la Pena',
        ref: '1 Pedro 3:18',
        text: {
            lbla: 'Porque también Cristo murió por los pecados una sola vez, el justo por los injustos, para llevarnos a Dios, muerto en la carne pero vivificado en el espíritu;'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-7',
        theme: 'Salvación no por Obras',
        ref: 'Efesios 2:8,9',
        text: {
            lbla: 'Porque por gracia habéis sido salvados por medio de la fe, y esto no de vosotros, sino que es don de Dios; no por obras, para que nadie se gloríe.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-8',
        theme: 'Salvación no por Obras',
        ref: 'Tito 3:5',
        text: {
            lbla: 'Él nos salvó, no por obras de justicia que nosotros hubiéramos hecho, sino conforme a su misericordia, por medio del lavamiento de la regeneración y la renovación por el Espíritu Santo,'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-9',
        theme: 'Debe Recibir a Cristo',
        ref: 'Juan 1:12',
        text: {
            lbla: 'Pero a todos los que le recibieron, les dio el derecho de llegar a ser hijos de Dios, es decir, a los que creen en su nombre,'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-10',
        theme: 'Debe Recibir a Cristo',
        ref: 'Apocalipsis 3:20',
        text: {
            lbla: 'He aquí, yo estoy a la puerta y llamo; si alguno oye mi voz y abre la puerta, entraré a él, y cenaré con él y él conmigo.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-11',
        theme: 'Seguridad de Salvación',
        ref: '1 Juan 5:13',
        text: {
            lbla: 'Estas cosas os he escrito a vosotros que creéis en el nombre del Hijo de Dios, para que sepáis que tenéis vida eterna.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Proclamar a Cristo',
        number: 'B-12',
        theme: 'Seguridad de Salvación',
        ref: 'Juan 5:24',
        text: {
            lbla: 'En verdad, en verdad os digo: el que oye mi palabra y cree al que me envió, tiene vida eterna y no viene a condenación, sino que ha pasado de muerte a vida.'
        }
    }
];

export default Items;